<template>
    <div style="margin:0 -12px;">
        <div class="luna-header-box">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-1">
                        <br>
                        <!-- 休止中ユーザーは設定画面以外へ遷移できないため、戻る導線を非表示 -->
                        <a v-if="user.id && !user.is_dormant" href="/home" class="link_1">
                            <i class="bi bi-chevron-left"></i>
                        </a>
                    </div>
                    <div class="col text-center" style="padding-top: 25px;">
                        <h5>設定</h5>
                    </div>
                    <div class="col-1">
                    </div>
                </div>
            </div>
        </div>
        <div class="wrap">
            <div class="container" style="margin-top:30px;">
                <br>
                <template v-if="!user.is_dormant">
                <div class="row" style="background:#F2F2F2;padding-top:15px;">
                    <div class="col">
                        <p><small style="color:#979C9E;">設定したユーザー</small></p>
                    </div>
                </div>
                <div class="row" style="padding: 10px;color:#6C7072;background:#fff;">
                    <div class="col d-flex align-items-center" onclick="window.location.href = '/setting/skip/list'">
                        <div class="luna-page-box-l">
                            <i class="bi bi-reply-fill"></i>&nbsp;&nbsp;スキップした人
                        </div>
                        <div class="text-center luna-page-box-r">
                            <i class="bi bi-chevron-right" style="color:#bbb;"></i>
                        </div>
                    </div>
                </div>
                <div class="row" style="padding: 10px;color:#6C7072;background:#fff;">
                    <div class="col d-flex align-items-center" onclick="window.location.href = '/setting/block/list'">
                        <div class="luna-page-box-l">
                            <i class="bi bi-bricks"></i>&nbsp;&nbsp;ブロックした人
                        </div>
                        <div class="text-center luna-page-box-r">
                            <i class="bi bi-chevron-right" style="color:#bbb;"></i>
                        </div>
                    </div>
                </div>
                <div class="row" style="padding: 10px;color:#6C7072;background:#fff;">
                    <div class="col d-flex align-items-center" onclick="window.location.href = '/setting/penalty/list'">
                        <div class="luna-page-box-l">
                            <i class="bi bi-exclamation-diamond-fill"></i>&nbsp;&nbsp;通報した人
                        </div>
                        <div class="text-center luna-page-box-r">
                            <i class="bi bi-chevron-right" style="color:#bbb;"></i>
                        </div>
                    </div>
                </div>
                </template>
                <div class="row" style="background:#F2F2F2;padding-top:15px;">
                    <div class="col">
                        <p><small style="color:#979C9E;">各種設定</small></p>
                    </div>
                </div>
                <div class="row" style="padding: 10px;color:#6C7072;background:#fff;">
                    <div class="col d-flex align-items-center" onclick="window.location.href = '/setting/status'">
                        <div class="luna-page-box-l">
                            <i class="bi bi-person-video"></i>&nbsp;&nbsp;会員ステータス
                        </div>
                        <div class="text-center luna-page-box-r">
                            <i class="bi bi-chevron-right" style="color:#bbb;"></i>
                        </div>
                    </div>
                </div>
                <div class="row" style="padding: 10px;color:#6C7072;background:#fff;">
                    <div class="col d-flex" onclick="window.location.href = '/setting/mail'">
                        <div class="luna-page-box-l">
                            <div>
                                <svg style="height:16px;width:16px;fill:#666;">
                                    <use xlink:href="/images/mail.svg#mail"></use>
                                </svg>&nbsp;&nbsp;メールアドレス設定
                            </div>
                            <div style="padding-left:26px;padding-top:5px;padding-bottom:5px;font-size:13px;color:#9990FF;">
                                {{ user.email }}
                            </div>
                        </div>
                        <div class="text-center luna-page-box-r">
                            <i class="bi bi-chevron-right" style="color:#bbb;"></i>
                        </div>
                    </div>
                </div>
                <div class="row" style="padding: 10px;color:#6C7072;background:#fff;">
                    <div class="col d-flex align-items-center" onclick="window.location.href = '/setting/password'">
                        <div class="luna-page-box-l">
                            <svg style="height:16px;width:16px;fill:#666;">
                                <use xlink:href="/images/lock.svg#lock"></use>
                            </svg>&nbsp;&nbsp;パスワード設定
                        </div>
                        <div class="text-center luna-page-box-r">
                            <i class="bi bi-chevron-right" style="color:#bbb;"></i>
                        </div>
                    </div>
                </div>
                <!-- ソーシャルログイン連携。プロフィール表示用の Twitter 設定とは別物。 -->
                <div class="row" style="padding: 10px;color:#6C7072;background:#fff;">
                    <div class="col d-flex" onclick="window.location.href = '/setting/social'">
                        <div class="luna-page-box-l">
                            <div>
                                <svg style="height:16px;width:16px;fill:#666;">
                                    <use xlink:href="/images/lock.svg#lock"></use>
                                </svg>&nbsp;&nbsp;ソーシャルアカウント連携
                            </div>
                            <div style="padding-left:26px;padding-top:5px;padding-bottom:5px;font-size:13px;color:#9990FF;">
                                {{ social_accounts_summary }}
                            </div>
                        </div>
                        <div class="text-center luna-page-box-r">
                            <i class="bi bi-chevron-right" style="color:#bbb;"></i>
                        </div>
                    </div>
                </div>
                <div v-if="!user.is_dormant" class="row" style="padding: 10px;color:#6C7072;background:#fff;">
                    <div class="col d-flex align-items-center" onclick="window.location.href = '/setting/search/view'">
                        <div class="luna-page-box-l">
                            <i class="bi bi-heart-fill"></i>&nbsp;&nbsp;募集のON/OFF
                        </div>
                        <div class="text-center luna-page-box-r">
                            <i class="bi bi-chevron-right" style="color:#bbb;"></i>
                        </div>
                    </div>
                </div>
                <div v-if="!user.is_dormant" class="row" style="padding: 10px;color:#6C7072;background:#fff;">
                    <div class="col d-flex align-items-center" onclick="window.location.href = '/setting/notification'">
                        <div class="luna-page-box-l">
                            <i class="bi bi-bell-fill"></i>&nbsp;&nbsp;通知設定
                        </div>
                        <div class="text-center luna-page-box-r">
                            <i class="bi bi-chevron-right" style="color:#bbb;"></i>
                        </div>
                    </div>
                </div>
                <div class="row" style="padding: 10px;color:#6C7072;background:#fff;">
                    <div class="col d-flex align-items-center" onclick="window.location.href = '/setting/dormant'">
                        <div class="luna-page-box-l">
                            <i class="bi bi-pause-circle-fill"></i>&nbsp;&nbsp;アカウント休止設定
                        </div>
                        <div class="text-center luna-page-box-r">
                            <i class="bi bi-chevron-right" style="color:#bbb;"></i>
                        </div>
                    </div>
                </div>
                <div class="row" style="padding: 10px;color:#6C7072;background:#fff;">
                    <div class="col d-flex align-items-center" onclick="window.location.href = '/setting/logout'">
                        <div class="luna-page-box-l">
                            ログアウト
                        </div>
                        <div class="text-center luna-page-box-r">
                            <i class="bi bi-chevron-right" style="color:#bbb;"></i>
                        </div>
                    </div>
                </div>
                <div class="row" style="padding: 10px;color:#6C7072;background:#fff;">
                    <div class="col d-flex align-items-center" onclick="window.location.href = '/setting/unsubscribe'">
                        <div class="luna-page-box-l">
                            退会
                        </div>
                        <div class="text-center luna-page-box-r">
                            <i class="bi bi-chevron-right" style="color:#bbb;"></i>
                        </div>
                    </div>
                </div>
                <div class="row" style="background:#F2F2F2;padding-top:15px;">
                    <div class="col">
                        <p><small style="color:#979C9E;">運営情報</small></p>
                    </div>
                </div>
                <div class="row" style="padding: 10px;color:#6C7072;background:#fff;">
                    <div class="col d-flex align-items-center"
                        onclick="window.open('https://luna-company.com/about', '_blank')">
                        <div class="luna-page-box-l">
                            運営会社
                        </div>
                        <div class="text-center luna-page-box-r">
                            <i class="bi bi-chevron-right" style="color:#bbb;"></i>
                        </div>
                    </div>
                </div>
                <div class="row" style="padding: 10px;color:#6C7072;background:#fff;">
                    <div class="col d-flex align-items-center"
                        onclick="window.open('https://luna-company.com/terms', '_blank')">
                        <div class="luna-page-box-l">
                            利用規約
                        </div>
                        <div class="text-center luna-page-box-r">
                            <i class="bi bi-chevron-right" style="color:#bbb;"></i>
                        </div>
                    </div>
                </div>
                <div class="row" style="padding: 10px;color:#6C7072;background:#fff;">
                    <div class="col d-flex align-items-center"
                        onclick="window.open('https://luna-company.com/privacy', '_blank')">
                        <div class="luna-page-box-l">
                            プライバシーポリシー
                        </div>
                        <div class="text-center luna-page-box-r">
                            <i class="bi bi-chevron-right" style="color:#bbb;"></i>
                        </div>
                    </div>
                </div>
                <br>
                <br>
                <br>
                <br>
            </div>
        </div>
    </div>
</template>

<script>
// 連携・解除の操作自体は /setting/social（React）が持ち、ここは要約を出すだけ。
export default {
    data() {
        return {
            user: [],
            social_accounts: [],
        };
    },
    computed: {
        // 表示名は API が provider_text で返すので、ここで対応表は持たない
        social_accounts_summary() {
            const names = (this.social_accounts || [])
                .map((account) => account.provider_text)
                .filter((name) => typeof name === 'string' && name.length > 0);

            return names.length > 0 ? `${names.join('・')}と連携中` : '未連携';
        },
    },
    methods: {
        async init() {
            await axios.get("/api/auth/user/get")
                .then(
                    (response) => {
                        this.fetchUsers()
                    }
                )
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast('ユーザーの取得に失敗しました。');
                    }
                })
        },
        async fetchUsers() {
            await axios.get("/api/user/get/me")
                .then((response) => {
                    this.user = response.data.user
                    this.social_accounts = response.data.user.social_accounts || []
                })
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast('ユーザーの取得に失敗しました。');
                    }
                })
        },
    },
    async created() {

        // 自動ログインチェック
        var arr = new Array();
        if (document.cookie != '') {
            var tmp = document.cookie.split('; ');
            for (var i = 0; i < tmp.length; i++) {
                var data = tmp[i].split('=');
                arr[data[0]] = decodeURIComponent(data[1]);
            }

            if (arr['uid'] != undefined) {
                await axios.get("/api/user/auth/" + arr['uid'])
                    .then(
                        (response) => {
                            this.init()
                        })
                    .catch((error) =>{
                        this.$showErrorToast('ユーザーの取得に失敗しました。');
                    })
            }
            else {
                this.init()
            }
        }
        else {
            this.init()
        }
    },
};
</script>
